import { render, staticRenderFns } from "./TheApiSystemRules.vue?vue&type=template&id=2c3bfcec&"
import script from "./TheApiSystemRules.vue?vue&type=script&lang=ts&"
export * from "./TheApiSystemRules.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports